import type { ReactNode } from "react";
import { useTranslations } from "use-intl";

import { CollapsibleCard } from "@/features/trips/components/CollapsibleCard";

type Props = {
  content: ReactNode;
};

export function AdditionalInformationCard({ content }: Props) {
  const t = useTranslations();

  return (
    <CollapsibleCard
      title={t("trips.additionalInformation.title")}
      expandedByDefault={false}
    >
      <div className="text-sm text-text-primary">{content}</div>
    </CollapsibleCard>
  );
}
